<template>
  <!-- OPÇÃO -->
  <div
    :class="{
      'select-options--group': option[this.hotelLabelKey]
    }"
    class="select-options--item"
  >
    <!-- GRUPO -->
    <div v-if="option[this.hotelLabelKey]">
      <p class="select-options--group-label">
        {{ option[this.hotelLabelKey] }}
      </p>

      <SelectOption
        v-for="groupOpt in option.options"
        :key="
          `select-group-option-${groupOpt[rateLabelKey] || i}-${
            groupOpt[rateValueKey]
          }`
        "
        :value="value"
        :label="
          capitalize
            ? groupOpt[rateLabelKey].toLowerCase()
            : groupOpt[rateLabelKey]
        "
        :inputValue="groupOpt"
        :checkbox="multiple"
        :disabled="groupOpt.disabled || disableSelectOption(groupOpt) || false"
        :class="{
          'select-options--option__capitalize': capitalize
        }"
        class="select-options--option"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
      />
    </div>

    <!-- ITEM FLAT (sem grupo) -->
    <SelectOption
      v-else
      :value="value"
      :label="
        capitalize ? option[rateLabelKey].toLowerCase() : option[rateLabelKey]
      "
      :inputValue="option"
      :checkbox="multiple"
      :disabled="option.disabled || disableSelectOption(option) || false"
      class="select-options--option"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
  </div>
</template>

<script>
import SelectOption from './SelectOption'

export default {
  name: 'SelectCouponOption',

  components: {
    SelectOption
  },

  props: {
    /** Array de tarifas selecionadas */
    value: {
      type: Array,
      default: () => []
    },

    /** Opção de tarifa */
    option: {
      type: Object,
      default: () => ({})
    },

    /** Se é uma seleção múltipla */
    multiple: Boolean,

    /** Se deve capitalizar os textos das labels */
    capitalize: Boolean,

    /** Chave de referência para usar como label do hotel */
    hotelLabelKey: {
      type: String,
      default: 'nome'
    },

    /** Chave de referência para usar como label da tarifa */
    rateLabelKey: {
      type: String,
      default: 'descricao'
    },

    /** Chave de referência para usar como valor da tarifa */
    rateValueKey: {
      type: String,
      default: 'codigo'
    },

    /** Função de tratamento para saber se a opção deve ser desabilitada */
    disableSelectOption: Function
  }
}
</script>

<style lang="scss" scoped>
.select {
  &-options {
    &--group-label {
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-medium');
    }

    &--item {
      width: 100%;
      white-space: nowrap;
      & + & {
        margin-top: 14px;
      }
    }

    &--group {
      & + & {
        padding-top: 15px;
        border-top: 1px solid $gray-border;
      }

      &:first-child {
        border: none;
      }

      & + &--item & {
        border-bottom: 1px solid $gray-border;
      }

      .select-option {
        margin-top: 18px;
      }
    }
  }
}
</style>
